import { Reveal } from "../components/Reveal";
import { MapPin, Clock, CalendarPlus } from "lucide-react";
import { useLang } from "../lib/i18n";
import { googleCalUrl, downloadIcs } from "../lib/calendar";

export const Weekend = () => {
  const { c } = useLang();
  return (
  <section id="weekend" className="py-28 sm:py-40 px-6" data-testid="weekend-section">
    <div className="max-w-5xl mx-auto">
      <Reveal>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight">
          {c.weekend.title} <span className="italic text-[#465220]">Miami</span>
        </h2>
      </Reveal>

      <div className="mt-20 space-y-0">
        {c.weekend.events.map((e, i) => (
          <Reveal key={e.id} delay={i * 0.08}>
            <div
              data-testid={`event-${e.id}`}
              className="group grid sm:grid-cols-[140px_1fr] gap-4 sm:gap-12 py-12 border-t border-[#DFE4D0] last:border-b hover:bg-[#EEF2E3]/60 transition-colors duration-500 sm:px-6 sm:-mx-6"
            >
              <div>
                <p className="font-serif-display font-light text-4xl text-[#C98A1B]">{String(i + 1).padStart(2, "0")}</p>
                <p className="font-serif-display italic text-2xl text-[#465220] mt-2">{e.day}</p>
                <p className="text-[11px] uppercase tracking-[0.25em] text-[#2C3552]/50 mt-2">{e.date}</p>
              </div>
              <div>
                <h3 className="font-serif-display font-medium text-3xl sm:text-4xl mb-4 group-hover:translate-x-2 transition-transform duration-500">
                  {e.title}
                </h3>
                <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-[#2C3552]/70">
                  <span className="inline-flex items-center gap-2">
                    <MapPin size={14} className="text-[#E15A70]" />
                    {e.place} · {e.address}
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <Clock size={14} className="text-[#E15A70]" />
                    {e.time}
                  </span>
                </div>
                <p className="mt-4 text-base font-light text-[#2C3552]/60 max-w-xl">{e.note}</p>
                {e.after && (
                  <p data-testid={`event-after-${e.id}`} className="mt-3 text-[11px] uppercase tracking-[0.2em] text-[#96475A]">
                    {e.after}
                  </p>
                )}
                <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-3">
                  {e.maps && (
                    <a
                      data-testid={`event-maps-link-${e.id}`}
                      href={e.maps}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[11px] uppercase tracking-[0.25em] text-[#465220] border-b border-[#465220]/40 pb-1 hover:border-[#465220] transition-colors duration-300"
                    >
                      Google Maps →
                    </a>
                  )}
                  <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.25em] text-[#2C3552]/40">
                    <CalendarPlus size={13} className="text-[#A9B08C]" />
                    {c.addToCalendar}
                  </span>
                  <a
                    data-testid={`event-gcal-${e.id}`}
                    href={googleCalUrl(e)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[11px] uppercase tracking-[0.25em] text-[#465220] border-b border-[#465220]/40 pb-1 hover:border-[#465220] transition-colors duration-300"
                  >
                    Google
                  </a>
                  <button
                    data-testid={`event-ics-${e.id}`}
                    onClick={() => downloadIcs(e)}
                    className="text-[11px] uppercase tracking-[0.25em] text-[#465220] border-b border-[#465220]/40 pb-1 hover:border-[#465220] transition-colors duration-300"
                  >
                    Apple / Outlook
                  </button>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
